import {
  BodyBlockV2Item,
  EBlockType,
  TemplateResponse,
  TStoreBlock,
} from 'constants/apiResponses.types';

export const BLOCK_TYPE_TO_BODY_BLOCK: Record<EBlockType, string> = {
  [EBlockType.BANNER]: 'banners',
  [EBlockType.BUNDLE]: 'bundles',
  [EBlockType.PROMOTION]: 'specialOffers',
  [EBlockType.ROLLING_OFFER]: 'rollingOffers',
  [EBlockType.ONE_PLUS_MANY]: 'onePlusMany',
  [EBlockType.DAILY_BONUS]: 'dailyBonus',
  [EBlockType.REWARD_CALENDAR]: 'rewardCalendar',
  [EBlockType.TRIGGERED_POPUP]: 'triggeredPopups',
  [EBlockType.PROGRESS_BAR]: 'progressBars',
  [EBlockType.RICH_TEXT]: 'richText',
};

const transformStoreBlocksToBodyBlocksV2 = (
  storeBlocks: TStoreBlock[],
): BodyBlockV2Item[] =>
  storeBlocks.flatMap((block) => {
    const bodyBlock = BLOCK_TYPE_TO_BODY_BLOCK[block.type];
    if (!bodyBlock) {
      return [];
    }
    return [{ blocks: [bodyBlock], isVisible: block.isVisible, isMergeable: false }];
  });

export const createBodyBlocksFromTemplate = (
  templateData: TemplateResponse | undefined,
): BodyBlockV2Item[] | undefined => {
  if (templateData === undefined) {
    return undefined;
  }
  const { storeBlocks } = templateData;
  if (storeBlocks && storeBlocks.length > 0) {
    const bodyBlocksFromStoreBlocks =
      transformStoreBlocksToBodyBlocksV2(storeBlocks);
    if (bodyBlocksFromStoreBlocks.length > 0) {
      return bodyBlocksFromStoreBlocks;
    }
  }
  return templateData.bodyBlocksOrderV2;
};
